import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { ALBUM_SUBTYPE } from '../../../../../../../constants/albums';
import { getCelebratedPersonName, getNameWithPossessive } from '../helpers';
import { videoIsProcessed } from '../../../../../../../util/video';
import Logo from '../../../../../../../components/global/Logo';
import GreetingVideo from './GreetingVideo';

const propTypes = {
  headerless: PropTypes.bool.isRequired,
  album: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  greetingVideo: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
};

const VGBContent = ({ headerless, album, greetingVideo }) => {
  const { event_settings: eventSettings } = album?.root_album_folder ?? {};
  const celebratedName = getCelebratedPersonName(
    album.album_subtype,
    eventSettings,
    false,
    album?.root_album_folder?.account?.organization_name ??
      album?.root_album_folder?.account?.name,
  );

  const posessiveCelebratedName = getCelebratedPersonName(
    album.album_subtype,
    eventSettings,
    true,
    album?.root_album_folder?.account?.organization_name ??
      album?.root_album_folder?.account?.name,
  );

  if (album.album_subtype === ALBUM_SUBTYPE.MEMORIALS) {
    const celebratedLastName = eventSettings.last_name;
    const celebratedFirstName = eventSettings.first_name;

    return (
      <Fragment>
        {!headerless && (
          <Fragment>
            <div className="mb-3">
              <Logo />
            </div>
            <h5 className="mb-1 text-center text-uppercase text-light">
              Welcome to the
            </h5>
            <h2 className="mb-3 text-black text-center">
              {celebratedLastName} family&apos;s Video Guestbook for{' '}
              {celebratedFirstName}
            </h2>
          </Fragment>
        )}
        {headerless && (
          <p className="h4 text-normal">
            The{' '}
            <span className="text-extra-bold">{celebratedLastName} family</span>{' '}
            is arranging a Video Guestbook for{' '}
            <span className="text-extra-bold">{celebratedFirstName}</span>.
          </p>
        )}
        {videoIsProcessed(greetingVideo) && (
          <Fragment>
            <p className="h4 text-normal">Watch the family&apos;s message :</p>
            <GreetingVideo greetingVideo={greetingVideo} className="mb-3" />
          </Fragment>
        )}
        <p className="h4 text-normal">
          Please leave your message in{' '}
          <span className="text-extra-bold text-primary">
            {getNameWithPossessive(celebratedName)}
          </span>{' '}
          Video Guestbook below:
        </p>
      </Fragment>
    );
  }

  return (
    <Fragment>
      {!headerless && (
        <Fragment>
          <div className="mb-3">
            <Logo />
          </div>
          <h5 className="mb-1 text-center text-uppercase text-light">
            Welcome to the
          </h5>
          <h2 className="mb-3 text-black text-center">
            {posessiveCelebratedName} Video Guestbook
          </h2>
        </Fragment>
      )}
      {headerless && (
        <p className="h4 text-normal">
          Help make{' '}
          <span className="text-extra-bold">{posessiveCelebratedName}</span>{' '}
          Video Guestbook amazing!
        </p>
      )}
      {videoIsProcessed(greetingVideo) && (
        <Fragment>
          <p className="h4 text-normal">Watch their greeting video here:</p>
          <GreetingVideo greetingVideo={greetingVideo} className="mb-3" />
        </Fragment>
      )}
      <p className="h4 text-normal">
        Please leave your message in{' '}
        <span className="text-extra-bold text-primary">
          {posessiveCelebratedName}
        </span>{' '}
        Video Guestbook below:
      </p>
    </Fragment>
  );
};

VGBContent.propTypes = propTypes;

export default VGBContent;
